/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import TimeSeriesValueCard from '@/components/kpi/TimeSeriesValueCard';
import type { TimeSeriesTrafficLightConfig, TimeSeriesValueLabelsConfig } from '@/lib/timeSeries/timeSeriesValue';

interface KpiValueStaticProps {
    conversion?: number;
    date?: string | null;
    fractionDigits?: number;
    info?: string;
    link?: string;
    modal?: {
        buttonLabel?: string;
        message: string;
        title?: string;
    };
    offset?: number;
    showLegend?: boolean;
    title?: string;
    trafficLight?: TimeSeriesTrafficLightConfig;
    unit?: string | null;
    value: number | null;
    valueLabels?: TimeSeriesValueLabelsConfig;
}

function KpiValueStatic({ date, ...props }: KpiValueStaticProps) {
    return <TimeSeriesValueCard {...props} metaDate={date} />;
}

export default KpiValueStatic;
